module.exports = {"id":"29552","name":"Shunsuke Nakamura","rating":"72","photo":"./data/images/photos/0/29552.png","club":{"name":"Iwata","logo":"./data/images/clubs/Iwata.png"},"positions":["MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ShunsukeNakamura0.json
// module id = 3944
// module chunks = 0